import { formatTimeSpanNormal, useLiveCounter } from "@buzzeasy/shared-frontend-utilities";
import { Space, theme, Typography } from "antd";
import { FC } from "react";
import { styled } from "styled-components";
import GraiaIcon from "../../assets/GraiaIcon";
import CenterContent from "../layouts/CenterContent";

const { Title } = Typography;

interface IProps {
  stateSince: Date;
}

const ActiveCallScreen: FC<IProps> = ({ stateSince }) => {
  const { token } = theme.useToken();

  const stateSinceInSec = useLiveCounter(stateSince);

  return (
    <CenterContent $backgroundColor={token.colorPrimary} $color={token.colorBgContainer}>
      <Space direction="vertical" size="large" align="center">
        <IconContainer>
          <StyledGraiaIcon />
        </IconContainer>
        <StyledTitle level={2}>Active Call</StyledTitle>
        <StyledTitle level={4}>{`Duration ${formatTimeSpanNormal(Math.max(0, stateSinceInSec))}`}</StyledTitle>
      </Space>
    </CenterContent>
  );
};

export default ActiveCallScreen;

const StyledTitle = styled(Title)`
  color: ${p => p.theme.colorBgContainer} !important;
`;

const IconContainer = styled.div`
  display: "flex";
  justify-content: "center";
  align-items: "center";
  padding-bottom: ${p => p.theme.sizeXXL}px; 
`;

const StyledGraiaIcon = styled(GraiaIcon)`
  width: ${p => p.theme.sizeXXL}px;
  height: ${p => p.theme.sizeXXL}px;
  color: ${p => p.theme.colorBgContainer};
`;
